import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../redux/slices/authSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import "./AdminCSS/profile.css"; // Import the CSS file

const ProfileModal = ({ show, handleClose }) => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.removeItem("access_token");
    dispatch(logoutUser());
    toast.success("Logged out successfully");
    setTimeout(() => {
      navigate("/login", { replace: true });
    }, 1000);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {user ? (
          <div className="profile-info">
            <div className="icon">
              <FaUserCircle />
            </div>
            <p>
              <strong>User ID:</strong> {user.admin_id}
            </p>
            <p>
              <strong>Username:</strong> {user.user_name}
            </p>
            <p>
              <strong>Email:</strong> {user.email}
            </p>
            <Button
              variant="danger"
              onClick={handleLogout}
              className="logout-button"
            >
              Logout
            </Button>
          </div>
        ) : (
          <p>Loading user data...</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProfileModal;
